module.exports = __webpack_public_path__ + "img/logo5.542d6f29.png";